module.exports = __webpack_public_path__ + "static/studies-614871876.eef19cf6.jpg";